import { Accordion } from "shared/ui/accordion";
import styles from "./EventQuestionsSection.module.scss";

export const EventQuestionsSection = () => {
  return (
    <div className={styles.questionsWrapper}>
      <p className={styles.questionsWrapper__title}>Частые вопросы</p>
      <div className={styles.questionsWrapper__accordionBlock}>
        <Accordion
          title="Где пройдет конгресс?"
          text='Мероприятие пройдет в комфортном и современном отеле "Реальянс" (ранее известном как "Ренессанс"). Будем рады встрече с вами по адресу: ул. Ново-Садовая, 162Б.'
        />
        <Accordion
          title="Как стать участником?"
          text="Все очень просто! Чтобы присоединиться к конгрессу, достаточно приобрести билет. Свяжитесь с нами и оформите заказ - мы уже ждем вас."
        />
        <Accordion
          title="Можно ли участвовать онлайн? Будет ли запись конгресса?"
          text="К сожалению, онлайн-участие и видеозапись не предусмотрены. Мы делаем ставку на живое общение, качественный нетворкинг и полное погружение в атмосферу события, поэтому конгресс пройдет исключительно в офлайн-формате."
        />
        <Accordion
          title="Возможно ли оплатить участие в конгрессе от организации?"
          text="Да, конечно! Вы без проблем можете оплатить билеты от лица вашей компании. При необходимости мы выставим счет на юридическое лицо."
        />
      </div>
    </div>
  );
};
